import React, {useState, useEffect, useMemo} from "react";
import {useNavigate} from "react-router-dom";
import Box from "@mui/material/Box";
import {Theme} from "../../Components/styles/styles";
import Typography from "@mui/material/Typography";

import axios from "axios";
import {getUrl} from "../../requests";
import {withAutocompleteLocalSearch} from "../../Components/AutocompleteLocalSearch/withAutocompleteLocalSearch";

import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import Paper from "@mui/material/Paper";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import {Modal} from "@mui/material";
import Privacy from "../../Components/Privacy/Privacy";
import {Button} from "@mui/material";
import {Helmet} from 'react-helmet-async';
import BasicInfo from "./BasicInfo";
import css from './SearchView.module.css'
import clsx from "clsx";
import {SeoArticle} from "./SeoArticle";
import {BlogArticle} from "./BlogArticle";
import LocalNews from "./LocalNews";

export const SearchView = (
    {
        sessionid,
        apikey
    }
) => {
    const navigate = useNavigate();

    const getPlace = (val) => {
        console.log("getPlace", val);
        if (val?.place_id) {
            axios
                .get(
                    `${getUrl()}/api/v1/places/details`,
                    {params: {sessionId: sessionid, placeId: val.place_id}},
                    {
                        headers: {},
                    }
                )
                .then((res) => {
                    const data = res.data.result;
                    localStorage.setItem("lat", data.geometry.location.lat);
                    localStorage.setItem("lng", data.geometry.location.lng);
                    const desc = val.description.replace("/", "%")
                    localStorage.setItem("searchedPlace", desc);
                    localStorage.setItem("placeID", val.place_id);
                    localStorage.setItem("ApiKey", apikey);
                    const expireMinutes = 60;
                    const now = new Date().getTime();
                    const envExpiry = now + expireMinutes * 60 * 1000;
                    localStorage.setItem("envExpiry", envExpiry);

                    navigate(`/wyniki/${desc}/${val.place_id}`, {
                        state: {
                            lat: data.geometry.location.lat,
                            lng: data.geometry.location.lng,
                            formatedAddress: data.formatted_address,
                        },
                    });
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    };

    const searcherKeyDown = (e) => {
    }

    const searcher = () => {
        return (
            <Box
                onKeyDown={searcherKeyDown}
                className={clsx(css.searcher)}
            >

                <Typography variant="h1" className={clsx(css.mainTitle)}>
                    Szukasz Internetu, telewizji lub telefonu?
                </Typography>

                <Typography variant="h4" className={clsx(css.subTitle)}>
                    Porównywarka ofert
                </Typography>

                <Box className={clsx(css.googleMapsAutocomplete)}>
                    <AutocompleteLocalSearchInstance/>
                </Box>

            </Box>
        )
    }

    const [footerMenuSelectedOption, setFooterMenuSelectedOption] = React.useState(3);
    const AutocompleteLocalSearchInstance = withAutocompleteLocalSearch(getPlace);

    const [isOpenPrivacyModal, setIsOpenPrivacyModal] = React.useState(false);

    const handleClosePrivacyModal = () => setIsOpenPrivacyModal(false);

    useEffect(() => {
        if (footerMenuSelectedOption === 0) navigate(`/logowanie/`);
        else if (footerMenuSelectedOption === 1)
            window.open("https://www.facebook.com/LokalniInternetBliskoCiebie", "_blank");
        else if (footerMenuSelectedOption === 2)
            window.open("https://www.instagram.com/lokalni_internet/", "_blank");
    }, [footerMenuSelectedOption]);

    return (
        <>
            <Helmet>
                <title>
                    Porównywarka ofert internetu i telewizji
                    - dostępność internetu, telewizji pod adresem
                    - Polscy operatorzy telekomunikacyjni
                    - Lokalni.pl
                </title>
                <meta
                    name="description"
                    content="Lokalni.pl - porównywarka ofert internetu i telewizji,
                             specjalizująca się w lokalnych dostawcach. Znajdź najlepsze usługi od
                             operatorów z Twojej okolicy!"
                />
            </Helmet>

            <Box className={clsx(css.searchView)}>
                <Box className={clsx(css.searchContainer)}>

                    {searcher()}

                    <Box className={clsx(css.article)}>

                        <Box className={clsx(css.mainArticle)}>
                            <BasicInfo/>
                        </Box>

                        <Box className={clsx(css.parentSeoArticle)}>
                            <SeoArticle/>
                        </Box>

                        <Box className={clsx(css.parentBlogArticle)}>
                            <BlogArticle/>
                        </Box>

                        <Box className={clsx(css.parentLocalNews)}>
                            <LocalNews/>
                        </Box>

                    </Box>

                </Box>

                <Paper
                    sx={{position: "fixed", bottom: 0, left: 0, right: 0}}
                    elevation={3}
                >
                    <BottomNavigation
                        showLabels
                        value={footerMenuSelectedOption}
                        onChange={(event, newValue) => {
                            setFooterMenuSelectedOption(newValue);
                        }}
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            backgroundColor: "#f2f3f5",
                            boxShadow: "0px -3px 8px rgba(0, 0, 0, 0.2)"
                        }}
                    >
                        <BottomNavigationAction
                            label="Zaloguj się"
                            icon={
                                <OpenInNewIcon
                                    sx={{
                                        color: "#f29a26",
                                        backgroundColor: "#fff",
                                    }}
                                />
                            }
                        />
                        <BottomNavigationAction
                            label="facebook"
                            icon={
                                <FacebookIcon
                                    sx={{
                                        color: "#1877F2",
                                        backgroundColor: "#fff",
                                    }}
                                />
                            }
                        />
                        <BottomNavigationAction
                            label="Instagram"
                            icon={
                                <InstagramIcon
                                    sx={{
                                        color: "#E4405F",
                                        backgroundColor: "#fff",
                                    }}
                                />
                            }
                        />
                        <BottomNavigationAction
                            sx={{
                                [Theme.breakpoints.up("tablet")]: {
                                    position: "absolute",
                                    right: "10px",
                                },
                            }}
                            label={
                                <Box
                                    onClick={() => {
                                        setIsOpenPrivacyModal(true);
                                    }}
                                    sx={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        flexDirection: "column",
                                        alignItems: "flex-end",
                                        [Theme.breakpoints.up("tablet")]: {
                                            width: "170px",
                                        },
                                    }}
                                >
                                    <Typography
                                        variant="bodyMediumReguralLinks"
                                        marginRight="16px"

                                        underline="none"
                                        target="_blank"
                                        color="#363636"
                                        textAlign="left"

                                    >
                                        Regulamin
                                    </Typography>
                                    <Typography
                                        variant="bodyMediumReguralLinks"
                                        marginRight="16px"

                                        underline="none"
                                        target="_blank"
                                        color="#363636"
                                        textAlign="left"

                                    >
                                        Polityka prywatności
                                    </Typography>
                                </Box>
                            }
                        />
                    </BottomNavigation>
                </Paper>


                <Modal
                    open={isOpenPrivacyModal}
                    onClose={handleClosePrivacyModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box
                        sx={{
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            position: "absolute",
                            borderRadius: "24px",
                            backgroundColor: "white",
                            paddingTop: "44px",
                            display: "flex",
                            flexDirection: "column",

                            [Theme.breakpoints.down("tablet")]: {
                                width: "90vw",
                            },
                        }}
                    >
                        <Privacy/>
                        <Button
                            onClick={() => {
                                handleClosePrivacyModal();
                            }}
                            sx={{
                                ...Theme.OrangeButton,
                                alignSelf: "flex-end",

                                mr: "44px",
                                mb: "44px",
                            }}
                        >
                            Zamknij
                        </Button>
                    </Box>
                </Modal>
            </Box>
        </>
    );
};
